import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./BookTableColumnPrefsInfo.module.css";

const COLUMN_PREFS_SETTINGS_PATH = "/settings?tab=table-columns";

const tooltipSlotProps = {
  tooltip: {
    className: styles.tooltipPaper,
    sx: {
      bgcolor: "var(--bg-elevated)",
      color: "var(--text-default)",
      border: "1px solid var(--border-default)",
      borderRadius: "10px",
      boxShadow: "0 6px 20px var(--shadow-key)",
      padding: 0,
      maxWidth: 240,
    },
  },
  arrow: {
    sx: {
      color: "var(--bg-elevated)",
      "&::before": {
        border: "1px solid var(--border-default)",
        boxSizing: "border-box",
      },
    },
  },
  popper: {
    sx: { pointerEvents: "auto" },
  },
};

function ColumnPrefsTooltipContent() {
  return (
    <span className={styles.tooltipContent}>
      <span className={styles.tooltipText}>You can change the order of table columns.</span>
      <Link to={COLUMN_PREFS_SETTINGS_PATH} className={styles.tooltipLink}>
        Go to Preferences
      </Link>
    </span>
  );
}

export default function BookTableColumnPrefsInfo() {
  return (
    <Tooltip
      title={<ColumnPrefsTooltipContent />}
      arrow
      placement="top"
      enterDelay={200}
      disableInteractive={false}
      slotProps={tooltipSlotProps}
    >
      <span
        className={styles.infoIconWrap}
        tabIndex={0}
        role="img"
        aria-label="Column order can be changed in Preferences"
      >
        <InfoOutlinedIcon fontSize="small" />
      </span>
    </Tooltip>
  );
}
